import {AfterViewInit, Component, HostListener, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-full-frame-dialog',
    templateUrl: './full-frame-dialog.component.html',
    styleUrl: './full-frame-dialog.component.scss',
    standalone: false
})
export class FullFrameDialogComponent{
	trustedIframeUrl: SafeResourceUrl;

	constructor(
		private sanitizer: DomSanitizer,
		public appService: AppService,
		public dialogRef: MatDialogRef<FullFrameDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.trustedIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.frameUrl);
	}

	onFrameLoaded(ev) {
		try {
			let _location = ev.currentTarget.contentWindow.location;
			if (_location.href) {

			}
		} catch (e) {

		}
	}

	close() {
		this.dialogRef.close({ mode: "cancel" });
	}
}
